<template>
  <div class="homePage">
    <mainDetail :mainDetail="mainDetail" class="main">
      <el-image
        :src="require('../../assets/icon/abilityImg1.png')"
        class="abilityImg1"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/abilityImg2.png')"
        class="abilityImg2"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/abilityImg3.png')"
        class="abilityImg3"
      ></el-image>
      <el-image
        :src="require('../../assets/icon/abilityImg4.png')"
        class="abilityImg4"
      ></el-image>
    </mainDetail>
    <div class="advantage">
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="title">
            <span>我们的优势</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="nav">
            <span>高质高效 卓越智能</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="16">
          <div
            class="card"
            v-for="(item, index) in advantageArr"
            :key="item.title"
          >
            <el-image :src="item.url" v-if="index % 2 === 0"></el-image>
            <div class="content">
              <div class="cardTitle">
                <div class="title-left" v-if="index % 2 === 0">
                  {{ item.title }}
                </div>
                <div class="title-right">
                  <span>{{ item.rightTitle }}</span>
                </div>
                <div class="title-left" v-if="index % 2 === 1">
                  {{ item.title }}
                </div>
              </div>
              <div class="text">{{ item.content }}</div>
            </div>
            <el-image :src="item.url" v-if="index % 2 === 1"></el-image>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="ability" id="ability">
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="title">
            <span>行业赋能</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="nav">
            <span>我们通过先进的自动化研发体系，已为众多行业领域赋能</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" style="z-index:98">
        <el-col :span="16">
          <el-row type="flex" justify="center" :gutter="20" class="topMain">
            <el-col :span="4" v-for="item in abilityArrTop" :key="item.text">
              <div class="content">
                <el-image
                  :src="item.url"
                  style="width:65px;height:65px"
                ></el-image>
                <div>{{ item.text }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" :gutter="20" class="bottomMain">
            <el-col v-for="item in abilityArrBotton" :key="item.text">
              <div class="content">
                <el-image
                  :src="item.url"
                  style="width:65px;height:65px"
                ></el-image>
                <div>{{ item.text }}</div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-image
        :src="require('../../assets/icon/background.svg')"
        class="backgroundImg"
      ></el-image>
    </div>
    <div class="cooperation" id="cooperation">
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="title">
            <span>合作共赢</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="12">
          <div class="nav">
            <span>优势互补 共赢未来</span>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center">
        <el-col :span="16">
          <el-row
            :gutter="20"
            v-for="(element, index) in cooperationImg"
            :key="index"
          >
            <el-col
              :span="6"
              :gutter="20"
              v-for="item in element"
              :key="item.url"
            >
              <div class="cooperationImg">
                <el-image :src="item.url" fit="scale-down"></el-image>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import mainDetail from "@/components/main/main";
export default {
  components: {
    mainDetail
  },
  data() {
    return {
      abilityArrTop: [
        {
          url: require("../../assets/icon/council.svg"),
          text: "政务"
        },
        {
          url: require("../../assets/icon/environmental.svg"),
          text: "环保"
        },
        {
          url: require("../../assets/icon/manufacture.svg"),
          text: "制造业"
        },
        {
          url: require("../../assets/icon/education.png"),
          text: "托育教育"
        },
        {
          url: require("../../assets/icon/community.svg"),
          text: "社区服务"
        },
        {
          url: require("../../assets/icon/school.png"),
          text: "高职院校"
        }
      ],
      abilityArrBotton: [
        {
          url: require("../../assets/icon/information.svg"),
          text: "信息技术"
        },
        {
          url: require("../../assets/icon/system.svg"),
          text: "系统集成"
        },
        {
          url: require("../../assets/icon/education.svg"),
          text: "教育培训"
        },
        {
          url: require("../../assets/icon/Administration.svg"),
          text: "企业管理"
        },
        {
          url: require("../../assets/icon/card.svg"),
          text: "人力资源"
        },
        {
          url: require("../../assets/icon/CRM.svg"),
          text: "CRM"
        }
      ],
      cooperationImg: [
        [
          {
            url: require("../../assets/icon/cooperationImg1.png")
          },
          {
            url: require("../../assets/icon/cooperationImg2.png")
          },
          {
            url: require("../../assets/icon/cooperationImg3.png")
          },
          {
            url: require("../../assets/icon/cooperationImg4.png")
          }
        ],
        [
          {
            url: require("../../assets/icon/cooperationImg5.png")
          },
          {
            url: require("../../assets/icon/cooperationImg6.png")
          },
          {
            url: require("../../assets/icon/cooperationImg7.png")
          },
          {
            url: require("../../assets/icon/cooperationImg8.png")
          }
        ],
        [
          {
            url: require("../../assets/icon/cooperationImg9.png")
          },
          {
            url: require("../../assets/icon/cooperationImg10.png")
          },
          {
            url: require("../../assets/icon/cooperationImg11.png")
          },
          {
            url: require("../../assets/icon/cooperationImg12.png")
          }
        ],
        [
          {
            url: require("../../assets/icon/cooperationImg13.png")
          },
          {
            url: require("../../assets/icon/cooperationImg14.png")
          },
          {
            url: require("../../assets/icon/cooperationImg15.png")
          },
          {
            url: require("../../assets/icon/cooperationImg16.png")
          }
        ]
      ],
      advantageArr: [
        {
          url: require("../../assets/icon/excellent.png"),
          title: "卓越的",
          rightTitle: "抽象与架构设计能力",
          content:
            "我们在多年的软件开发过程中，从未停歇对企业应用的基础架构的研究与优化。这是信息技术新基建的地基，将助您快速构建高性能、更稳定、易扩展的各类应用。"
        },
        {
          url: require("../../assets/icon/Quality.png"),
          title: "自动化研发体系",
          rightTitle: "高质高效的",
          content:
            "专研：我们专业的研发团队，致力于推动低代码、RPA等信息技术自动化方面的研究与应用。精深：团队成员平均软件开发经验近10年，经数十个大小项目各类场景历练。开放：推出了自动化开发平台Diboot，开发者都可以受益于我们的自动化开发体系。"
        },
        {
          url: require("../../assets/icon/continued.png"),
          title: "持续的",
          rightTitle: "前沿技术研究与应用",
          content:
            "业务中台、数据中台、接口平台、低代码、RPA...，我们密切关注新技术、新方案，大胆尝试，谨慎选择。对新兴技术的研究，使我们具备更广的视野和更多的创新活力，也助力我们为您提供更加契合的解决方案。"
        },
        {
          url: require("../../assets/icon/intelligences.png"),
          title: "共享服务解决方案",
          rightTitle: "智能的",
          content:
            "我们打造的智能云端计算平台为自动化软件研发体系赋能，助力软件开发效率和质量的大幅提升。打破烟囱式建设带来的后遗症，我们持续探索实践，积累中台、云平台的企业服务共享解决方案。"
        }
      ],
      mainDetail: {
        h1: "专注于低代码开发平台",
        lis: [
          "化繁为简，以简驭繁；匠心磨砺，终得利锋！",
          "高质高效的自动化开发体系，",
          "助您解决软件研发的质量效率可维护性难题。"
        ],
        type:'HomePage',
        buttonText: "免费使用",
        buttonImg: require("../../assets/icon/robot.png"),
        mainImg: require("../../assets/icon/main.png")
      }
    };
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped lang="less">
.homePage {
  background-color: #fafafb;
  padding-bottom: 130px;
}
.main {
  position: relative;
  .abilityImg1 {
    position: absolute;
    top: 68%;
    right: 34%;
    width: 8%;
    z-index: 99;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .abilityImg2 {
    position: absolute;
    top: 92%;
    right: 26%;
    width: 6%;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .abilityImg3 {
    position: absolute;
    top: 1%;
    right: 10%;
    width: 20%;
    z-index: 99;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
  .abilityImg4 {
    position: absolute;
    top: 83%;
    right: 5%;
    width: 12%;
    z-index: 99;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      transform: translateY(-10px);
    }
  }
}
.title {
  font-size: 28px;
  font-weight: bold;
  text-align: center;
  letter-spacing: 14px;
  span {
    background: linear-gradient(to right, #55baf7, #0fe50f);
    background-clip: text;
    color: transparent;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 170%;
      left: 50%;
      transform: translateX(-50%) skewX(30deg);
      width: 60px;
      height: 7px;
      background: linear-gradient(to right, #55baf7, #0fe50f);
      border-radius: 5px;
    }
  }
}
.nav {
  color: #55baf7;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 40px;
  font-size: 18px;
  letter-spacing: 1px;
}
.topMain .el-col:last-child .content {
  border-radius: 0 50% 0 0;
}
.bottomMain .el-col:first-child .content {
  border-radius: 0 0 0 50%;
}

.ability {
  padding-top: 120px;
  position: relative;
  .backgroundImg {
    position: absolute;
    width: 15%;
    left: 0;
    top: -25%;
  }
  .content {
    height: 170px;
    margin-top: 30px;
    transition: all 0.3s;
    background-color: #fff;
    box-shadow: 1px 1px 1px 1px #eee;
    text-align: center;
    padding-top: 30px;
    box-sizing: border-box;
    font-size: 18px;
    color: #666;
    &:hover {
      box-shadow: 10px 10px 10px 3px #eee;
      cursor: pointer;
    }
    .el-image {
      margin-bottom: 20px;
    }
  }
}
.cooperation {
  padding-top: 120px;
  .cooperationImg {
    background-color: #f0f0f0;
    height: 80px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    transition: all 0.3s ease 0s;
    &:hover {
      cursor: pointer;
      opacity: 1;
      filter: grayscale(0);
      -webkit-filter: grayscale(0);
        background: #E7F4FF!important;
    }
    .el-image {
      width: 100%;
      height: 100%;
    }
  }
}
.advantage {
  margin-top: 50px;
  .card {
    margin-top: 30px;
    background-color: #fff;
    box-shadow: 3px 6px 20px 3px #eee;
    transition: all 0.3s;
    border-radius: 0 0 50px 50px;
    display: flex;
    .el-image {
      flex: 2;
      border-radius: 0 0 0 50px;
    }
    .content {
      flex: 5;
      padding: 15px 40px;
      .cardTitle {
        display: flex;
        margin-bottom: 10px;
        .title-left {
          font-size: 30px;
          margin-right: 30px;
          line-height: 40px;
          letter-spacing: 2px;
        }
        .title-right {
          display: flex;
          align-items: flex-end;
          font-size: 18px;
          line-height: 30px;
          letter-spacing: 1px;

          span {
            position: relative;

            &::before {
              content: "";
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #63c3ac;
              position: absolute;
              top: 50%;
              left: -15px;
              transform: translateY(-50%);
            }
          }
        }
      }
      .text {
        color: #9b9b9b;
        font-size: 16px;
        line-height: 30px;
        letter-spacing: 1px;
      }
    }
    &:hover {
      transform: translateY(-10px);
      cursor: pointer;
    }
    &:nth-child(2n) {
      border-radius: 50px 50px 0 0;
      .cardTitle {
        display: flex;
        justify-content: flex-end;
        .title-left {
          font-size: 30px;
          margin-left: 30px;
          margin-right: 0;
          line-height: 40px;
        }
        .title-right {
          display: flex;
          align-items: flex-end;
          font-size: 18px;
          line-height: 25px;

          span {
            position: relative;

            &::after {
              content: "";
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #63c3ac;
              position: absolute;
              top: 50%;
              right: -15px;
              transform: translateY(-50%);
            }
            &::before {
              width: 0;
              height: 0;
            }
          }
        }
      }
      .el-image {
        border-radius: 0 50px 0 0;
      }
    }
  }
}

.el-divider {
  width: 15%;
  height: 10px;
  margin: 24px auto;
  background: linear-gradient(to right, skyblue, #0fe50f);
  border-radius: 5px;
  transform: skewX(30deg);
}
</style>
